import styled from 'styled-components';

export const ButtonContainer = styled.div`
  margin: 8px 0 16px 0;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ModalContent = styled.div`
  width: 100%;
  min-width: 600px;
  max-height: 75vh;
  overflow-y: auto;
  padding: 32px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    min-width: auto;
    padding: 16px;
  }
`;

export const TranscriptionCard = styled.div`
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 16px;
  background: #fafafa;
`;

export const TranscriptionMeta = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #666;

  span {
    font-weight: 500;
  }
`;

export const MedicalSummarySection = styled.div`
  margin: 16px 0;
  padding: 16px;
  background: #f0f7ff;
  border-left: 4px solid #1976d2;
  border-radius: 4px;
`;

export const MedicalSummaryTitle = styled.h3`
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: #1976d2;
`;

export const MedicalSummaryText = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
`;

export const TranscriptLabel = styled.h4`
  margin: 16px 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TranscriptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Utterance = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

export const SpeakerLabel = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.color || '#1976d2'};
  min-width: 100px;
  text-transform: uppercase;
  padding-top: 2px;
`;

export const Timestamp = styled.div`
  font-size: 14px;
  font-weight: 700;
  font-family: monospace;
  color: #1976d2;
  text-transform: none;
`;

export const UtteranceText = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  flex: 1;
`;

export const TranscriptionText = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

export const ErrorText = styled.div`
  color: #d32f2f;
  font-size: 12px;
  margin-left: 8px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 16px;
  text-align: center;
`;

export const EmptyStateText = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const EmptyStateSubtext = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
`;
